import auth from '@/i18n/en/auth'
import common from '@/i18n/en/common'
import currencies from '@/i18n/en/currencies'
import docs from '@/i18n/en/docs'
import errors from '@/i18n/en/errors'
import fields from '@/i18n/en/fields'
import org from '@/i18n/en/org'
import plurals from '@/i18n/en/plurals'
import ui from '@/i18n/en/ui'
import validations from '@/i18n/en/validations'

export default {
  ...auth,
  ...common,
  ...currencies,
  ...docs,
  ...errors,
  ...fields,
  ...org,
  ...plurals,
  ...ui,
  ...validations,
}
